//存入用户jwt
export const addJwt = (jwt)=>{
  localStorage.setItem("jwt", jwt);
};

//获取用户jwt
export const getJwt = ()=>{
  return localStorage.getItem("jwt");
};


//清除登陆状态
export const cleanLoginStatus = ()=>{
  localStorage.removeItem("jwt");
};



// WEBPACK FOOTER //
// ./src/js/utils/loginUtils.js